import { useButtonStatContext } from 'common/builder/components/chart/FlowChart/contexts/ButtonStatContext'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { calculateCTR, formatCTR } from 'utils/stats'

export const useButtonCtrLabel = (button: FlowChartButton): string | null => {
  const { showButtonStats, totalUsers } = useButtonStatContext()

  if (!showButtonStats || button.stats.users === null) {
    return null
  }

  const value = calculateCTR(button.stats.users, totalUsers)

  return `CTR ${formatCTR(value)}`
}
